import { render, staticRenderFns } from "./NewAppointment.vue?vue&type=template&id=2a93278e&"
import script from "./NewAppointment.vue?vue&type=script&lang=js&"
export * from "./NewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./NewAppointment.vue?vue&type=style&index=0&id=2a93278e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports